import { render, staticRenderFns } from "./EditCatalogModal.vue?vue&type=template&id=6f2f23e6&scoped=true"
import script from "./EditCatalogModal.vue?vue&type=script&lang=js"
export * from "./EditCatalogModal.vue?vue&type=script&lang=js"
import style0 from "./EditCatalogModal.vue?vue&type=style&index=0&id=6f2f23e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f23e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2f23e6')) {
      api.createRecord('6f2f23e6', component.options)
    } else {
      api.reload('6f2f23e6', component.options)
    }
    module.hot.accept("./EditCatalogModal.vue?vue&type=template&id=6f2f23e6&scoped=true", function () {
      api.rerender('6f2f23e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/EditCatalogModal.vue"
export default component.exports